<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <table-temp
      :flag="1"
      :tableData="tableData"
      :columnData="publishConf"
      :isEdit="false"
      :showSummary="true"
      :summaryMethod="getSummaries"
    ></table-temp>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { step5 } from "@/conf/Report-manager";
import TableTemp from "@table/table";
// import {  } from "common/js/api";

export default {
  components: {
    TableTemp,
  },

  props: ["dialogVisible", "title", "tableData"],

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      isManager: true,
      publishConf: step5,
    };
  },

  created() {
    // 设置配环境
    //this.setEnvironment();
  },

  mounted() {
    //this.setConf();
  },

  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => {
          if (column.property === "capitalInvested") {
            return Number(item[column.property]);
          } else if (column.property === "fundRealValue") {
            return Number(item[column.property]);
          } else return;
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    handleClose() {
      this.$emit("closeDialog");
    },
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
    },
    // isBackShow(newValue) {
    //   if(newValue) {
    //     this.dataSource = step5;
    //     this.getManagerSelect();
    //     this.getnation();
    //   }else {
    //     this.dataSource = step2;
    //     this.getManagerSelect();
    //   }
    // }
  },
};
</script>
